import { useState } from "react";
import { Loader2, CheckCircle2, Send } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { sendLead } from "@/lib/simranChat";

export const SimranLead = ({ question, page, i }) => {
  const { L } = useLang();
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setState("sending"); setErr("");
    try { await sendLead({ question, name, contact, page }); setState("sent"); }
    catch (ex) { setState("idle"); setErr(ex?.response?.data?.detail || L("Could not send. Please try again.", "भेज नहीं पाए। फिर कोशिश करें।")); }
  };
  if (state === "sent") {
    return <div className="mt-2 rounded-xl bg-emerald-50 border border-emerald-200 px-3 py-2 text-xs font-semibold text-emerald-800 flex items-center gap-2" data-testid={`simran-lead-sent-${i}`}><CheckCircle2 className="w-4 h-4" />{L("Sent! Our team will reply to you soon.", "भेज दिया! हमारी टीम जल्द आपको जवाब देगी।")}</div>;
  }
  return (
    <form onSubmit={submit} className="mt-2 rounded-xl bg-[#FFF8E6] border border-[#FCD34D] p-3 space-y-2" data-testid={`simran-lead-form-${i}`}>
      <div className="text-xs font-bold text-[#7A4A00]">{L("Leave your mobile or email and our team will confirm this for you.", "अपना मोबाइल या ईमेल छोड़िए, हमारी टीम आपको पक्की जानकारी देगी।")}</div>
      <input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} placeholder={L("Your name (optional)", "आपका नाम (वैकल्पिक)")} data-testid={`simran-lead-name-${i}`}
        className="w-full h-9 rounded-lg border border-slate-200 bg-white px-3 text-xs outline-none focus:border-[#14B8A6]" />
      <div className="flex gap-2">
        <input value={contact} onChange={(e) => setContact(e.target.value)} required maxLength={120} placeholder={L("Mobile number or email", "मोबाइल नंबर या ईमेल")} data-testid={`simran-lead-contact-${i}`}
          className="flex-1 min-w-0 h-9 rounded-lg border border-slate-200 bg-white px-3 text-xs outline-none focus:border-[#14B8A6]" />
        <button type="submit" disabled={state === "sending" || contact.trim().length < 5} data-testid={`simran-lead-submit-${i}`}
          className="h-9 px-3 rounded-lg bg-[#0B1F3A] text-white text-xs font-bold inline-flex items-center gap-1 disabled:opacity-40">
          {state === "sending" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}{L("Send to team", "टीम को भेजें")}
        </button>
      </div>
      {err && <div className="text-[11px] text-red-600" data-testid={`simran-lead-error-${i}`}>{err}</div>}
    </form>
  );
};
